import useEmotionStyles from "@styles/shared/useEmotionStyles";
import { TableHomeTaskStlye } from "@styles/layout/TableHomeTaskStlye";
import { RubricTable } from "@components/common/RubricTable";
import { IRubricInfo } from "@repositories/model/transfer/IRubricInfo";

type Props = {
	rubricInfo: IRubricInfo
}

export const ProjectRubricTable = (props: Props) => {
	const classes = useEmotionStyles(TableHomeTaskStlye);
	const { rubricInfo } = props;

	return (
		<RubricTable
			rubricInfo={rubricInfo}
			variant="shared"
			classes={classes}
		/>
	);
}






